import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";

const NUMBER = "233546080065";
const DISPLAY = "+233 546 080 065";
const PREFILL = encodeURIComponent(
  "Hello OpsIQ — I'd like to talk about Operational Intelligence for my business."
);
const HREF = `https://wa.me/${NUMBER}?text=${PREFILL}`;

export default function WhatsAppFab() {
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  // Open the mini card automatically the first time a visitor lands, after a beat.
  useEffect(() => {
    if (sessionStorage.getItem("opsiq_wa_seen")) return;
    const t = setTimeout(() => {
      setOpen(true);
      sessionStorage.setItem("opsiq_wa_seen", "1");
    }, 3200);
    return () => clearTimeout(t);
  }, []);

  if (dismissed) return null;

  return (
    <div
      data-testid="whatsapp-fab-wrap"
      className="fixed z-[60] bottom-5 left-5 md:bottom-6 md:left-6 flex flex-col items-start gap-3 pointer-events-none"
    >
      {open && (
        <div
          data-testid="whatsapp-fab-card"
          className="pointer-events-auto max-w-[280px] bg-white text-[#1A2E4A] shadow-2xl rounded-lg overflow-hidden"
          style={{ animation: "opsiqFadeIn 220ms ease-out" }}
        >
          <div className="flex items-center justify-between gap-3 px-4 py-3 bg-[#1A2E4A] text-[#F1ECE0]">
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-[#25D366] animate-pulse" />
              <span className="text-[10px] font-plex-mono uppercase tracking-[0.2em]">OpsIQ · Online</span>
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Close WhatsApp prompt"
              data-testid="whatsapp-fab-close"
              className="text-[#F1ECE0]/70 hover:text-[#D9FF3C] transition-colors"
            >
              <X size={14} />
            </button>
          </div>
          <div className="px-4 py-3">
            <div className="text-sm leading-snug">
              Hi <span className="font-semibold">there</span> — questions about dashboards, KPIs, or a project?
              Message us on WhatsApp and we&apos;ll usually reply within the hour.
            </div>
            <a
              href={HREF}
              target="_blank"
              rel="noreferrer"
              data-testid="whatsapp-fab-card-cta"
              className="mt-3 inline-flex items-center gap-2 px-3.5 py-2.5 bg-[#25D366] text-white text-[10px] uppercase tracking-[0.2em] font-semibold hover:opacity-90 transition-opacity w-full justify-center"
            >
              <MessageCircle size={14} /> Chat on WhatsApp
            </a>
            <div className="mt-2 text-[10px] font-plex-mono uppercase tracking-[0.18em] text-[#1A2E4A]/50 text-center">
              {DISPLAY}
            </div>
          </div>
        </div>
      )}

      <a
        href={HREF}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-fab"
        aria-label="Chat with OpsIQ on WhatsApp"
        onMouseEnter={() => setOpen(true)}
        className="pointer-events-auto relative inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.55)] hover:scale-[1.06] active:scale-95 transition-transform"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping" />
        <MessageCircle size={26} strokeWidth={2} className="relative" />
      </a>
    </div>
  );
}
